<template lang="pug">
	
	.political-slider
	
		.horizontal-wrapper

			.slider
				.wrap-elements
					.element
						.overlay
							.wrap-text
								p.text(v-html="translate('political.slider.slider_1')") 

						cover-image(src="assets/images/political-slide-1.jpg").images
					.element
						.overlay
							.wrap-text
								p.text(v-html="translate('political.slider.slider_2')")
						cover-image(src="assets/images/political-slide-2.jpg").images
					.element
						.overlay
							.wrap-text
								p.text(v-html="translate('political.slider.slider_3')")
						//- img(src="assets/images/political-slide-3.jpg").images
						video(src='assets/videos/slider-video-badass.mp4' poster='assets/images/political-slide-3.jpg' controls=false autoplay loop muted).images
					
					

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '../../../utils/scroller.js'
	import Ticker from '../../../utils/ticker.js'
	import * as PIXI from 'pixi.js'
	import Scrollable from '../../../abstracts/scrollable'
	import CoverImage from '../../../components/images-elements/image-cover.vue'
	
  	@Component({
		name: 'PoliticalSlider',
		components: { CoverImage }
	})

	class PoliticalSlider extends Scrollable {

		mounted () {

			super.mounted()

			this.$elements = $(this.$el).find('.element')
			this.$wrapSlider = this.$el.querySelector('.wrap-elements')
		
			this.$slider = this.$el.querySelector('.horizontal-wrapper')
			this.$images = this.$el.querySelectorAll('.element .images')
			this.$wrapTexts = this.$el.querySelectorAll('.element .wrap-text')
			this.$texts = this.$el.querySelectorAll('.element .text')

		}

		init () {
			
			super.init()

		}
		
		_bind () {
			super._bind()
		}
    

    initTimeline () {
      	super.initTimeline()
		let moveY = (window.innerHeight * .1) / this.newHeight

		this.tl.fromTo(this.$slider,1,{y:0},{y:this.newHeight, ease:Power0.easeNone})
		this.tl.fromTo(this.$wrapSlider,1,{x:0},{x: -(this.newHeight + this.left), ease: Power0.easeNone},0)
			
        const firstTextLeft = this.$wrapTexts[0].getBoundingClientRect().left
        const lastTextLeft = this.$wrapTexts[2].getBoundingClientRect().left

        for(let i = 0; i < this.$elements.length; i++) {
        	let left = this.$elements.get(i).getBoundingClientRect().left
        	let width = this.$elements.get(i).getBoundingClientRect().width
              
        	const textLeft = this.$wrapTexts[i].getBoundingClientRect().left
        	const textWidth = this.$wrapTexts[i].getBoundingClientRect().width
          
        	const toX = textLeft - firstTextLeft
        	const start = _.clamp((left - window.innerWidth) / (this.newHeight + this.left), 0, 1)
        	const dur = _.clamp( (width - (window.innerWidth - left)) / (this.newHeight + this.left), 0, width/(this.newHeight + this.left) )

        	const test1 = _.clamp((left - window.innerWidth) / this.newHeight, 0, 1)

        	this.tl.fromTo(this.$texts[i],1,{x: -toX},{x: (lastTextLeft - textLeft), ease:Power0.easeNone},0)
        	this.tl.fromTo(this.$images[i],dur,{x:-_.clamp(left - width, 0, 10000000) * .4, scale:1},{x: 0,ease:Power0.easeNone},start)

        }


        const testLeft = this.$elements.get(0).getBoundingClientRect().left 
        let testWidth = this.$elements.get(0).getBoundingClientRect().width

        const startLeft = _.clamp((testLeft - window.innerWidth) / this.newHeight, 0, 1)
        
        const outStart = (testLeft / (this.newHeight + this.left))
        const outDur = testWidth/(this.newHeight + this.left)

        this.tl.to(this.$images[0],outDur,{x: _.clamp(300, 0, 10000000) * .4,ease:Power0.easeNone},outStart)

        const testLeft1 = this.$elements.get(1).getBoundingClientRect().left
        let testWidth1 = this.$elements.get(1).getBoundingClientRect().width

        const outStart1 = (testLeft1 / (this.newHeight + this.left))
        const outDur1 = (testWidth1 - this.left ) /(this.newHeight + this.left)

        this.tl.to(this.$images[1],outDur1,{x: _.clamp(300, 0, 10000000) * .4,ease:Power0.easeNone},outStart1)
    
    }

    raf (y) {
			super.raf(y)	
	}

	_on () {
		super._on()
	}

	_off () {
		super._off()
	}

	_resize () {
      super._resize()

      this.left = parseInt(window.getComputedStyle(this.$el.querySelector('.slider'), null).getPropertyValue('padding-left'))

	this.newHeight = this.$wrapSlider.getBoundingClientRect().width - window.innerWidth + this.left
	
	this.bounds.height = window.innerHeight + this.newHeight
	this.$el.style.height = this.bounds.height + "px"
      
      this.boundsAnim = {
			top: this.bounds.top,
			bottom: this.bounds.top + this.newHeight
      }
      
      this.initTimeline()
			
		}	

	}

	export default PoliticalSlider

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.political-slider
		width 100%
	
		.horizontal-wrapper
			width 100%
			height 100vh
			overflow hidden
			will-change transform

			.slider
				height 100vh
				width 9999px
				display flex
				align-items center
				padding-left 20vw

				+break(xs)
					padding-left 2vw

				.wrap-elements
					display flex
					// will-change transform

					.element
						height 60vh
						width 60vw
						overflow hidden
						position relative
						
						// +break(minlg)
						// 	width 1440px

						.overlay
							position absolute
							top 0
							left 0
							height 100%
							width 100%
							display flex
							align-items center
							justify-content center
							background-color rgba(#000,.6)
							z-index 80

							p
								color #fff
								max-width 400px
								text-align center
								text-transform uppercase
								font-size em(30px)
								line-height em(35px,30px)
								letter-spacing .15em
								font-weight 600
								font-family $FONT_SECONDARY

								+break(minlg)
									max-width 550px

								+break(minxlg)
									max-width 700px

						+break(xs)
							width calc(100vw - 6vw)
							height 80vh

						&:nth-child(2)
							margin 0 2vw
							// transform translateX(20vw)
						
						img,video
							height 100%
							width 100%
							object-fit cover
							// will-change transform
							position relative
							z-index 60

</style>


// WEBPACK FOOTER //
// political-slider.vue?d0601fea